export default __webpack_public_path__ + "static/media/not_sleep_maker_movie.bab70727.gif";